import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthorizationsTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/admin-authorizations-tab'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/admin-authorizations',
)({
  component: AdminAuthorizationsTabRoute,
})

function AdminAuthorizationsTabRoute() {
  const tab = useStoreProjectModalTab()
  return (
    <AdminAuthorizationsTab
      form={tab.form}
      canEdit={tab.canEdit}
      onAutoDateModeChange={tab.handleAutoDateModeChange}
    />
  )
}
